var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import * as React from 'react';
/**
 * Hook used to enable media query listeners at specified ViewSizes.
 * @returns The valid view size to determine the appropriate `View` component to render.
 */
export function useMediaQueries(props) {
    var viewSizes = props.viewSizes, baseFontSizePx = props.baseFontSizePx;
    var mediaQueryLists;
    if (typeof window !== 'undefined') {
        mediaQueryLists = Object.entries(viewSizes).map(function (_a) {
            var _b = __read(_a, 2), _ = _b[0], value = _b[1];
            return [
                value,
                window.matchMedia("(min-width: ".concat(baseFontSizePx ? value * baseFontSizePx : value, "px)")) // If using baseFontSizePx, need to multiply by baseFontSizePx to get actual min-width
            ];
        });
    }
    var getValidViewSize = function () {
        var validViewSize = viewSizes.SMALL;
        if (typeof window !== 'undefined' && mediaQueryLists.length > 0) {
            var defaultValidMediaQuery = mediaQueryLists[0];
            var validMediaQueryList = mediaQueryLists
                .filter(function (mql) { return mql[1].matches; })
                .reduce(function (_a, _b) {
                var _c = __read(_a, 2), validSize = _c[0], validMql = _c[1];
                var _d = __read(_b, 2), currentSize = _d[0], currentMql = _d[1];
                if (validSize > currentSize) {
                    return [validSize, validMql];
                }
                return [currentSize, currentMql];
            }, defaultValidMediaQuery);
            validViewSize = validMediaQueryList[0];
        }
        return validViewSize;
    };
    var _a = __read(React.useState(getValidViewSize), 2), viewSize = _a[0], setViewSize = _a[1];
    React.useEffect(function () {
        var handler = function () { return setViewSize(getValidViewSize); };
        if (mediaQueryLists && mediaQueryLists.length > 0) {
            mediaQueryLists.forEach(function (mql) { return mql[1].addListener(handler); });
        }
        // remove listeners on cleanup
        return function () {
            if (mediaQueryLists && mediaQueryLists.length > 0) {
                mediaQueryLists.forEach(function (mql) { return mql[1].removeListener(handler); });
            }
        };
    }, []);
    return viewSize;
}
//# sourceMappingURL=use-media-queries.js.map